import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

import { getReportOptionsQueryKey } from './useReportOptions';

function deleteReportOption(id: number): Promise<Response> {
  return remove(`/api/report-options/${id}`);
}

/**
 * Hook for deleting an existing saved report option.
 *
 * @param organizationId - Used to invalidate the report options query cache after deletion.
 */
export function useDeleteReportOption(organizationId: number) {
  return useToastedMutation({
    mutationFn: deleteReportOption,
    successToastMessage: 'Report option deleted successfully.',
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: getReportOptionsQueryKey(organizationId) });
    },
  });
}
